import { Injectable, inject } from '@angular/core'
import { MatPaginatorIntl } from '@angular/material/paginator'
import { Subject } from 'rxjs'
import { TranslationService } from '../../services/translation.service'

@Injectable()
export class PaginatorIntl implements MatPaginatorIntl {
  private translationService = inject(TranslationService)

  changes = new Subject<void>()

  firstPageLabel = this.translationService.getFirstPageText()
  itemsPerPageLabel = this.translationService.getItemsPerPageText()
  lastPageLabel = this.translationService.getLastPageText()

  nextPageLabel = this.translationService.getNextPageText()
  previousPageLabel = this.translationService.getPreviousPageText()

  /**
   * Returns page label for Custom Paginator
   * @param page
   * @param pageSize
   * @param length
   * @returns
   */
  getRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0) {
      return this.translationService.getRangeLabelText(1, 1)
    }
    const amountPages = Math.ceil(length / pageSize)
    return this.translationService.getRangeLabelText(page + 1, amountPages)
  }
}
